import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import axiosClient from "../../service/axios";
import { genotypeToast } from "../NotificationToast";

function Genotype({ genotype, setGenotype, orderDetails, ...props }) {
  const [genotypePrice, setGenotypePrice] = useState("");
  const [loading, setLoading] = useState(false);
  const isCrossMatching = props?.chargeType === "crossmatching";
  const chargeTitle = isCrossMatching ? "Cross Matching" : "Genotype";
  //   console.log("orderDetails", orderDetails)
  //   console.log("data", props)
  // console.log("req", request)

  const handleModalClose = () => {
    setGenotypePrice("");
    setGenotype(false);
  };

  useEffect(() => {
    if (genotype) {
      setGenotypePrice("");
    }
  }, [genotype, isCrossMatching, props?.id]);

  const handleSubmit = async () => {
    const payload = isCrossMatching
      ? {
          order_id: props?.id,
          title: props?.title,
          crossmatch_cost: genotypePrice,
        }
      : {
          order_id: props?.id,
          title: props?.title,
          genotype_cost: genotypePrice,
        };

    const endpoint = isCrossMatching
      ? "/lite/v2/api/v3/add/crossmatching"
      : "/lite/v2/api/v3/add/genotyping";

    setLoading(true);

    try {
      const response = await axiosClient.post(endpoint, payload);

      if (response?.status === 200) {
        genotypeToast();
        setGenotype(false);
        setGenotypePrice("");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={genotype} onClose={handleModalClose}>
        <DialogContent style={{ paddingBottom: "0" }}>
          <DialogTitle>
            <p style={{ fontSize: "20px", fontWeight: "bold" }}>
              Enter Price For {chargeTitle}{" "}
              <span style={{ fontSize: "30px", color: "#B70303" }}>
                {props?.productName}
              </span>
            </p>
          </DialogTitle>

          <div>
            <input
              name="genotypePrice"
              type="number"
              value={genotypePrice}
              onChange={(e) => setGenotypePrice(e.target.value)}
              placeholder={`${chargeTitle} Price`}
              style={{
                width: "100%",
                height: "50px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "16px",
                color: "#333",
                marginBottom: "20px",
              }}
            />
          </div>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingRight: "23px",
          }}
        >
          <div
            style={{
              cursor: "pointer",
              color: "#fff",
              backgroundColor: "#B70303",
              padding: "10px",
              borderRadius: "3px",
              border: "1px solid #DFE1E6",
              fontSize: "14px",
              textAlign: "center",
            }}
            onClick={handleSubmit}
          >
            {loading ? "Loading..." : "Submit"}
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Genotype;
